module.exports = __webpack_public_path__ + "9841e6ec86c47c52e4def23d36c3b494.svg";